import React, { createContext, useContext, useState } from 'react';

const PanelContext = createContext();

export const usePanel = () => {
    return useContext(PanelContext);
};

export const PanelProvider = ({ children }) => {
    const [isPanelVisible, setIsPanelVisible] = useState(true);

    const togglePanelVisibility = () => {
        setIsPanelVisible(!isPanelVisible);
    };

    return (
        <PanelContext.Provider value={{ isPanelVisible, togglePanelVisibility }}>
            {children}
        </PanelContext.Provider>
    );
};